function scrollDown(scroll_position) {
    if (scroll_position > 0) {
        $("header#header").addClass("scroll");
    } else {
        $("header#header").removeClass("scroll");
    }
}

function anchorScrolling(anchor, animation_duration) {
    animation_duration === undefined ? animation_duration = 500 : null;
    $('html, body').animate({
        scrollTop: $(anchor).offset().top - 120
    }, animation_duration);
}

function _get_form_token(){
    $.get(
        site_url + '/ajax/functions.php?operation=_get_form_token',
        function(resp) {
            $("input[name=_token][type=hidden]").each( function(){
                this.value = resp
            })		
        }		
    );
}

$(function () {

    _get_form_token();

    //Acts when scroll down page.
    if ($("body#home").length > 0) {
        $(window).scroll(function (event) {
            let top = $(document).scrollTop();
            scrollDown(top);
        });
    }

    $("a.fancybox").on("click", function (e) {
        e.preventDefault();
    });

    $("body.weddings #formRFP #meeting_date").attr("placeholder", "Weeding Date *");

    let arrow_position = $("a[data-bottom]");
    arrow_position.each(function () {
        $(this).css('bottom', $(this).data('bottom'));
    });

    // Remove empty <p> tags created by tinymce
    document.querySelectorAll('p').forEach(e => {
        if (e.innerHTML === '') e.remove();
    });

    $(window).load(function () {

        $('.sym-slides').slick();

        $("body").css("opacity", 1);

        //SCROLLING
        if (window.location.hash) {
            scroll(0, 0);
            const $anchor = "#" + window.location.href.split('#')[1];
            console.log($anchor);
            if ($anchor !== "#") {
                anchorScrolling($anchor, 1);
            }
        }

        $("a.scroll").off('click').on('click', function (e) {
            e.preventDefault();
            let $anchor = $(this).attr("href");
            anchorScrolling($anchor);
        });

    });


}());